import {useEffect} from 'react';
import {fabric} from 'fabric';

const MIN_IMAGE_SIZE = 0.1;
const MAX_IMAGE_SIZE = 2;

export const useImageResizeListener = (canvas) => {
  useEffect(() => {
    if (!canvas) return;

    const enforceSizeLimits = (obj) => {
      // eslint-disable-next-line no-underscore-dangle
      if (!obj || obj.type !== 'uYOImage' || !obj._originalElement) return;

      const originalScale = fabric.util.findScaleToCover(obj, obj._originalObject);
      const currentScale = obj.scaleX / originalScale;

      if (currentScale < MIN_IMAGE_SIZE) {
        const newScale = originalScale * MIN_IMAGE_SIZE;
        obj.scale(newScale);
        canvas.requestRenderAll();
      } else if (currentScale > MAX_IMAGE_SIZE) {
        const newScale = originalScale * MAX_IMAGE_SIZE;
        obj.scale(newScale);
        canvas.requestRenderAll();
      }
    };

    const handleScaling = (e) => {
      enforceSizeLimits(e.target);
    };

    canvas.on('object:scaling', handleScaling);

    // eslint-disable-next-line consistent-return
    return () => {
      canvas.off('object:scaling', handleScaling);
    };
  }, [canvas]);

  return null;
};
